import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "@environments/environment";
import {Observable} from "rxjs";
import {Result} from "@domain/common/http/result";
import {Tolerance} from '@domain/typecharge/tolerance';

/**
 * Service de gestion des Tolérances
 */
@Injectable()
export class FacturesToleranceService {

    /**
     * Constructeur
     *
     * @param http pour permettre de réaliser les requêtes
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Sauvegarde d'une tolérance
     *
     * @param tolerance Tolérance à sauvegarder
     * @returns Observable contenant le résultat de l'opération
     */
    saveTolerance(tolerance: Tolerance): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/tolerance/update`, tolerance);
    }
}
